import { render, staticRenderFns } from "./CollapseExtended.vue?vue&type=template&id=8f385ebe&scoped=true"
import script from "./CollapseExtended.vue?vue&type=script&lang=js"
export * from "./CollapseExtended.vue?vue&type=script&lang=js"
import style0 from "./CollapseExtended.vue?vue&type=style&index=0&id=8f385ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f385ebe",
  null
  
)

export default component.exports